import { Component } from "@angular/core";
import { Router, RouterModule } from "@angular/router";

@Component({
  selector: "app-online-courses",
  imports: [RouterModule],
  templateUrl: "./online-courses.component.html",
  styleUrl: "./online-courses.component.scss",
})
export class OnlineCoursesComponent {}
